import { ThemeVariables } from '@material-ui/core/styles/createMuiTheme';

const variables: ThemeVariables = {
  drawerWidth: 240,
  headerHeight: 64,
  headerHeightUpSm: 64,
  tabbarHeight: 48,
  contentPadding: 12,
  contentPaddingUpSm: 24,
  boxShadow: '0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 5px 8px 0px rgba(0, 0, 0, 0.14), 0px 1px 14px 0px rgba(0, 0, 0, 0.12)',
  colors: {
    facebook: '#3b5998',
    google: '#de5245'
  }
};

export default variables;


// WEBPACK FOOTER //
// ./src/assets/theme/variables.tsx